export function hasConsentUpdated(): boolean {
    (window as any).dataLayer = (window as any).dataLayer || [];
    return Boolean(
        ((window as any).dataLayer?.findLast?.((it) => it[0] === 'consent') || [])[1] === 'update',
    );
}
